import { computed, inject } from '@angular/core';
import type { MachineCatalogEntry } from '@indutrust/machine-model';
import {
  withCrudEntitiesEvents,
  withLoadAllOnAuthEvents,
  withOrderedEntities,
} from '@indutrust/shared-util';
import { signalStore, withComputed } from '@ngrx/signals';
import { MachineCatalogApiClient } from '../machine-catalog-api-client.service';
import { machineCatalogCrudEvents } from './machine-catalog.events';

/**
 * Root store for the shared machine catalog — auto-loads on auth.
 *
 * Exposes `approvedEntities` for the supplier-facing picker (search /
 * autocomplete). Admin queue filtering lives on
 * {@link import('./admin-machine-catalog.store').AdminMachineCatalogStore}.
 *
 * @example
 * const catalog = inject(MachineCatalogStore);
 * const approved = catalog.approvedEntities();
 */
export const MachineCatalogStore = signalStore(
  { providedIn: 'root' },
  withCrudEntitiesEvents<MachineCatalogEntry>(machineCatalogCrudEvents, () =>
    inject(MachineCatalogApiClient)
  ),
  withLoadAllOnAuthEvents(machineCatalogCrudEvents),
  withOrderedEntities<MachineCatalogEntry>(),
  withComputed(({ entities }) => ({
    approvedEntities: computed(() =>
      entities().filter((entry) => entry.status === 'approved')
    ),
  }))
);
